import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Utilities
import { required, between, slug } from '../../utilities/validation';

// FormState
export class CreateNetworkFormState {
  name = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(3, 30));
  alias = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 30), slug);
  description = new FieldState('')
    .disableAutoValidation()
    .validators(between(0, 250));
  publicAccess = new FieldState('PRIVATE');
  accessKey = new FieldState('')
    .disableAutoValidation()
    .validators(between(0, 32));

  state = new FormState({
    name: this.name,
    alias: this.alias,
    description: this.description,
    publicAccess: this.publicAccess,
    accessKey: this.accessKey
  });

  gerValues() {
    return {
      name: this.name.$,
      alias: this.alias.$,
      description: this.description.$,
      publicAccess: this.publicAccess.$ === 'PUBLIC',
      accessKey: this.publicAccess.$ === 'PUBLIC' ? '' : this.accessKey.$
    };
  }
}

// Components
import { Form, TextField, Select } from '../../components/FormStateFields';

// Component
interface IProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  formState: CreateNetworkFormState;
}

function CreateNetworkForm(props: IProps) {
  return (
    <Form onSubmit={props.onSubmit}>
      <TextField
        label="Name"
        type="text"
        fieldState={props.formState.name}
        margin="normal"
        fullWidth={true}
      />
      <TextField
        label="Alias"
        type="text"
        fieldState={props.formState.alias}
        margin="normal"
        fullWidth={true}
      />
      <TextField
        label="Description"
        type="text"
        fieldState={props.formState.description}
        margin="normal"
        fullWidth={true}
      />
      <Select
        label={'Privacy'}
        fieldState={props.formState.publicAccess}
        options={[
          { value: 'PRIVATE', label: 'Private' },
          { value: 'PUBLIC', label: 'Public' }
        ]}
        margin={'normal'}
        fullWidth={true}
      />
      <TextField
        label="Access Key"
        type="password"
        fieldState={props.formState.accessKey}
        margin="normal"
        fullWidth={true}
        disabled={!(props.formState.publicAccess.value === 'PRIVATE')}
      />
      <button
        tabIndex={-1}
        style={{
          position: 'absolute',
          opacity: 0,
          top: 0,
          left: 0
        }}
        type={'submit'}
      />
    </Form>
  );
}

export default observer(CreateNetworkForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogCreateForm.tsx